import * as $ from "jquery";

$(document).ready(function () {
  $(".menu-trigger--label").click(function () {
    $("body").toggleClass("active-navigation");
    $("aside").toggle();
  });

  $(".topic-wrapper").click(function () {
    $(this).parent().toggleClass("folded");
  });

  $(".jumplink").bind("click", function (e) {
    if (!$("body").hasClass("edit")) {
      e.preventDefault();
      var target = $("#continued");
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $(target).offset().top,
          },
          300,
          "swing"
        );
    }
  });

  var prev = 0;
  var $window = $(window);
  var social = $(".modular-social-bar");

  $window.on("scroll", function () {
    var scrollTop = $window.scrollTop();
    stickifyMenu();
    social.toggleClass("hidden", scrollTop > prev);
    prev = scrollTop;
  });
});

function stickifyMenu() {
  var windowHeight = window.innerHeight;
  var heroHeight = 0;
  var bottomStop = windowHeight;

  var belowHeroElement = document.getElementsByClassName("below-hero");
  var contentHubMicrositeSectionCtaElement = document.getElementsByClassName(
    "imkt-content-hub-microsite--section--cta"
  );

  if (belowHeroElement.length) {
    heroHeight = belowHeroElement[0].offsetTop;
  }

  if (contentHubMicrositeSectionCtaElement.length) {
    bottomStop =
      contentHubMicrositeSectionCtaElement[0].offsetTop - windowHeight;
  }

  if (window.scrollY > heroHeight && window.scrollY < bottomStop) {
    $(".agile-sidebar-column").addClass("stuck-top");
    $(".agile-sidebar-column").removeClass("stuck-bottom");
  } else if (window.scrollY > bottomStop) {
    $(".agile-sidebar-column").removeClass("stuck-top");
    $(".agile-sidebar-column").addClass("stuck-bottom");
  } else {
    $(".agile-sidebar-column").removeClass("stuck-bottom stuck-top");
  }
}

function toggleMenu() {
  if (window.location.hash === "#navigation") {
    $("body").addClass("sidebar-toggled");
  } else {
    $("body").removeClass("sidebar-toggled");
  }
}

toggleMenu();

window.addEventListener(
  "hashchange",
  function () {
    toggleMenu();
  },
  false
);
